import { connect } from 'react-redux';

import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';
import { Card } from '@hivebrite/design-system/Card';
import { Divider } from '@hivebrite/design-system/Divider';
import { useInterval } from '@hivebrite/react-hooks';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { fetchFollowings } from 'hb-react/shared/apps/Topics/actions/followings';
import SuccessCircleCheck from 'hb-react/shared/icons/SuccessCircleCheck';

const TopicDispatcher = ({ followedByUser, fetchFollowingsAction }) => {
  useInterval(
    () => {
      fetchFollowingsAction();
    },
    followedByUser ? null : 2000,
  );

  return null;
};

const TopicReduxProxy = connect(
  (state, { topicId, userId }) => {
    const followedByUser = !!state.followings
      .get('followings')
      .find(
        (following) =>
          following.get('topic_id') === Number(topicId) &&
          following.get('user_id') === Number(userId),
      );

    return {
      followedByUser,
    };
  },
  (dispatch, { topicId }) => ({
    fetchFollowingsAction: () => dispatch(fetchFollowings(topicId)),
  }),
)(TopicDispatcher);

const SuccessStep = ({ memberships = [] }) => {
  const { currentUser } = useDefaultAppContexts();
  const { topicId } = useTopicContext();

  if (memberships.length === 0) {
    return null;
  }

  const [membership] = memberships;

  const {
    _links,
    meta: { success_page: successPage, headline },
  } = membership;

  return (
    <Box display="block">
      {topicId && <TopicReduxProxy topicId={topicId} userId={currentUser.id} />}
      <Card width="100%">
        {headline && (
          <>
            <Box>
              <Box color="grass">
                <SuccessCircleCheck
                  title={__('Success')}
                  width="30px"
                  height="30px"
                />
              </Box>
              <Box font="h3-semibold" pl="4" pt="1">
                {headline}
              </Box>
            </Box>
            <Divider borderBottomColor="#cdcdcd" mt={3} width="100%" />
          </>
        )}
        <Box
          flexDirection="column"
          dangerouslySetInnerHTML={{
            __html: successPage,
          }}
        />
      </Card>
      <NavBar links={_links} />
    </Box>
  );
};

const NavBar = ({ links }) => (
  <Box mt={6}>
    <ButtonInLink
      linkProps={{
        to: Routes.me_my_memberships_path(),
      }}
    >
      {s__('Memberships|See my memberships')}
    </ButtonInLink>
    <ButtonInLink
      linkProps={{
        to: links.index,
      }}
      ml={4}
      variant="secondary"
    >
      {s__('Memberships|Go to memberships page')}
    </ButtonInLink>
  </Box>
);

export default SuccessStep;
